import { useState } from "react";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/slice/userSlice";

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    var err = false;

    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

    if (!email) {
      setEmailError("Email is required");
      err = true;
    } else if (!emailRegex.test(email)) {
      setEmailError("Not a valid email");
      err = true;
    }

    if (!err) {
      const data = { email };
      dispatch(forgotPassword(data));
    }

    // const data = { email };
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-5">
        {/* Email input container */}
        <div className="flex flex-col gap-3">
          <label htmlFor="email" className="text-textPrimary font-medium ">
            Email Address*
          </label>
          <input
            type="text"
            id="email"
            name="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="Enter email address"
            autoFocus
          />

          <span className="pl-4 text-[12px] italic text-red-500">
            {emailError}
          </span>
        </div>

        {/*  reset button */}
        <div className="flex text-center flex-col mt-4 gap-6">
          <button
            type="submit"
            className="h-[52px] bg-secondary rounded-md text-primary text-xl font-medium"
          >
            Reset password
          </button>
        </div>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
